class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('[data-predictive-search-results]');
    this.status = this.querySelector('[data-predictive-search-status]');
    this.abortController = null;
    this.debounceTimer = null;
    if (!this.input || !this.results) return;
    this.input.addEventListener('input', () => this.onInput());
    this.input.addEventListener('keydown', (event) => this.onKeydown(event));
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.close();
    });
  }

  onInput() {
    clearTimeout(this.debounceTimer);
    const term = this.input.value.trim();
    if (term.length < 2) {
      this.close();
      return;
    }
    this.debounceTimer = setTimeout(() => this.fetchResults(term), 180);
  }

  async fetchResults(term) {
    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();
    const base = this.dataset.predictiveSearchUrl;
    const sectionId = this.dataset.sectionId || 'predictive-search';
    const url = `${base}?q=${encodeURIComponent(term)}&section_id=${encodeURIComponent(sectionId)}&resources[type]=product,collection,page,article,query&resources[limit]=8&resources[options][unavailable_products]=last`;
    this.setLoading(true);
    try {
      const response = await fetch(url, { signal: this.abortController.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);
      const text = await response.text();
      const documentFragment = new DOMParser().parseFromString(text, 'text/html');
      const markup = documentFragment.querySelector('#shopify-section-predictive-search')?.innerHTML || '';
      this.results.innerHTML = markup;
      this.open();
      const count = this.results.querySelectorAll('[data-predictive-result]').length;
      if (this.status) this.status.textContent = count ? `${count} results available` : 'No suggestions available';
    } catch (error) {
      if (error.name !== 'AbortError') {
        this.results.innerHTML = '';
        this.close();
      }
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(isLoading) {
    this.toggleAttribute('data-loading', isLoading);
    this.input.setAttribute('aria-busy', String(isLoading));
  }

  open() {
    this.results.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.results.hidden = true;
    this.input.setAttribute('aria-expanded', 'false');
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      this.close();
      this.input.focus();
    }
  }
}

if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);
